/**
 * Issue: #5997
 *
 * バックエンド (FTS5 snippet) は <mark>...</mark> タグ付きで excerpt を返す.
 * 安全に React レンダリングするため、独自 parser で「テキスト or mark」の
 * 配列に分解する (dangerouslySetInnerHTML を避ける).
 */

export type ExcerptToken =
  | { type: "text"; text: string }
  | { type: "mark"; text: string };

const MARK_RE = /<mark>([^<]*)<\/mark>/g;

export function parseExcerpt(excerpt: string | null | undefined): ExcerptToken[] {
  const s = excerpt ?? "";
  if (!s) return [];
  const tokens: ExcerptToken[] = [];
  let lastIndex = 0;
  MARK_RE.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = MARK_RE.exec(s)) !== null) {
    if (m.index > lastIndex) {
      tokens.push({ type: "text", text: s.slice(lastIndex, m.index) });
    }
    tokens.push({ type: "mark", text: m[1] ?? "" });
    lastIndex = m.index + m[0].length;
  }
  if (lastIndex < s.length) {
    tokens.push({ type: "text", text: s.slice(lastIndex) });
  }
  return tokens;
}
